<template>
  <article class="new-sub-title">
    <!-- <h2>{{ topMenuName }}</h2>
    <p>{{ menuInfo }}</p> -->
    <!-- <ul class="btn_share">
      <li>
        <a href="#n" class="btn_facebook" title="새창으로 열림" @click="shareFacebook"><span class="hidden">페이스북</span></a>
      </li>
      <li>
       <a href="#n" class="btn_twitter" title="새창으로 열림" @click="shareTwitter"><span class="hidden">트위터</span></a>
      </li>
	  <li>
		<a href="#n" role="button" class="btn_print" @click="print($event)"><span class="hidden">인쇄</span></a>
      </li>
    </ul> -->
    <nav id="subGnb" v-show="$route.matched[0].path === '/subject'">
      <div class="sg-inner">
        <ul>
          <li name="subMenuItem" class="on" v-for="route in routeChildren">
            <a href="#n" class="dep3-arr" :class="{'on': isSelectedSubMenu(route), 'depth-on': route.meta.subMenuItemMgmNo}" @click="eventClickSubMenu($event, route)">{{ route.name }}</a>
            <div v-if="route.meta.subMenuItemMgmNo" ref="subMenuItem" class="tab-dep3">
              <ul v-if="route.meta.subMenuItemMgmNo">
                <li v-for="subMenuItem in findSubMenuItems(route.meta.subMenuItemMgmNo)">
                  <a href="#n" class="cate-menu" @click="eventClickSubMenuItem($event, route, subMenuItem)">{{ subMenuItem.title }}</a>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </nav>
  </article>
</template>

<script>
import $ from 'jquery'

export default {
	name: 'SubMenu',
	data () {
		return {
			up: false,
			routePath: '',
			subMenuData: [],
      previousMenuPopup: null
		}
	},
	created () {
		window.addEventListener('scroll', this.eventMenuTextSlide)
	},

	destroyed () {
		window.removeEventListener('scroll', this.eventMenuTextSlide)
	},

	mounted () {
		document.addEventListener('click', (e) => {
			if(e.target.classList[0] != 'dep3-arr') {
				document.querySelectorAll('.dep3-arr').forEach((item)=>{
					item.classList.remove('active');
				});
			}
		})
	},
	updated () {

	},
	computed: {
		routeChildren () {
			if ((this.routePath === this.$route.matched[0].path) && this.subMenuData) {
				return this.subMenuData
			}

			this.routePath = this.$route.matched[0].path
			this.subMenuData = this.getSubMenuData(this.routePath)

			return this.subMenuData
		},

		topMenuName () {
			return this.$route.matched[0].name
		},
		menuInfo () {
			if (this.$route.meta && (this.$route.meta.menuInfo === undefined || this.$route.meta.menuInfo === '')) {
				return '메뉴 소개글 없다.'
			}
			return this.$route.meta.menuInfo
		}

	},
	methods: {
        print(evt) {
			window.print()
			evt.preventDefault()
        },

		eventMenuTextSlide () {
			const scrollTop = $(window).scrollTop()
			const title = $('.sub-title > .title')
			if (scrollTop >= 75) {
				title.addClass('scroll')
			} else {
				title.removeClass('scroll')
			}
		},

		findSubMenuItems (subMenuId) {
			const subMenuItem = this.$store.getters.findSubMenu(subMenuId)
			if (subMenuItem) {
				return subMenuItem.items
			}
			return []
		},

		openMenuPopup(element) {
			if (this.previousMenuPopup) {
				$(this.previousMenuPopup.children[0]).stop().slideUp();
			}

			$(element.children[0]).stop().slideDown();
			this.previousMenuPopup = element;
		},

		closeMenuPopup(element) {
			$(element.children[0]).stop().slideUp();
			this.previousMenuPopup = null;
		},

		async eventClickSubMenu (event, subMenu) {
			if (event.target) {
				const subMenuItemDiv = event.target.nextElementSibling
				if (subMenuItemDiv && subMenuItemDiv.children) {
					//INFO 하의 메뉴가 있으면 슬라이드 처리
					$(event.target).parent().siblings().find('> .dep3-arr').removeClass('active');
					event.target.classList.toggle("active");
					event.preventDefault();
				} else {
          			//하의 메뉴가 없으면 메뉴 이동
					let params = {}
					let routePath = ''

					if (subMenu) {
						routePath = subMenu.name;

						if (subMenu.component) {
							if (subMenu.meta.subMenuItemMgmNo) {
								params = {
									subItemId: subMenu.meta.subMenuItemMgmNo
								}
							}
							setTimeout(async () => {
								await this.$router.push({name: routePath, params: params});
							}, 0);
						} else {
							if (subMenu.meta.linkUrl) {
								window.open(subMenu.meta.linkUrl)
							}
						}
					}

					if (this.previousMenuPopup) {
						$(this.previousMenuPopup.children[0]).stop().slideUp();
					}

					this.previousMenuPopup = null;
				}
			}
		},

		isSelectedSubMenu (subMenu) {
			if (this.$route.name === subMenu.name) {
				return true
			} else {
				if (this.$route.name.indexOf(subMenu.name) > -1 && this.$route.name.indexOf('상세') > -1) {
					return true
				}
			}
			return false
		},

		eventClickSubMenuItem (event, route, subMenuItem) {
			for (const subMenuItemDiv of this.$refs.subMenuItem) {
				$(subMenuItemDiv.children[0]).parents('.tab-dep3').prev().removeClass('active')
			}

			if (subMenuItem) {
				const params = {
					subItemId: subMenuItem.mgmNo,
					subItemNm: subMenuItem.title,
					upMgmNo: subMenuItem.upMgmNo
				}
				this.$router.push({ name: route.name, params: params })
			}
    	  	event.preventDefault();
		},

		getSubMenuData (path) {
			const subMenus = []
			const children = this.$router.options.routes
			if (path) {
				let chunks = path.split('/')
				chunks = chunks.filter((chunk) => chunk !== '')
				if (chunks.length) {
					if (children) {
						const found = children.find((child) => child.path === path)
						if (found) {
							for (const subMenu of found.children) {
								if (subMenu.meta.visible) {
									subMenus.push(subMenu)
								}
							}
						}
					}
				}
			}
			return subMenus
		}
	}
}
</script>

<style scoped>

</style>
